import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import { nowUtil } from '../../../utils/dates/date.utils';
import { YYYY } from '../../../utils/dates/dateFormats.utils'
import { ALL_USER_ROLES } from '../../../constants/roles/userRoleTypes.js';
import { adjustUTCToLocalTime } from '../../../utils/dates/dateMethods.js';


const GeorgiaFooter = props => {

    const {
        environment: {
            devEnvironment,
            exchangeName,
            links: {
                LOGO_URL,
                PRIVACY_POLICY,
                SIGNUP_AGENCY,
                SIGNUP_AGENT_BROKER,
                SIGNUP_ENROLLMENT_ENTITIES
            },
            localDates: {
                timezoneOffsetMs=0,
                dstSavingsMs=0,
                serverDateInUTC,
                timezone,
            },
            user
        },
    } = props;


    const src = global.__ENV__.PRODUCTION ? '/hix/resources/img/footer-ga_img.png' : '/assets/images/footer-ga_img.png';
    const currentYear = nowUtil(YYYY);

    const { sDate, sTime } = adjustUTCToLocalTime(serverDateInUTC, timezoneOffsetMs, dstSavingsMs);

    return(
        <Fragment>
            <footer id='footer--ga' className='usa-footer' role='contentinfo'>
                <div className='usa-footer-primary-section gi-footer__container'>
                    <div className='usa-grid usa-footer__primary-section gi-footer__primary-section'>
                            <a href={ LOGO_URL } className='gi-footer__image' target='_blank'>
                                <img
                                    src = { src }
                                    alt='Georgia Access'
                                />
                            </a>
                            <div className="gi-footer__info">
                                <span>&#169;</span><FormattedMessage id='footer.copyright' values={{  date: currentYear, exchangeName }}/>
                            </div>
                            <a target='_blank' href={ PRIVACY_POLICY } rel='noopener noreferrer' className='gi-footer__link'title='Link open in new window or tab'>
                                <FormattedMessage id='footer.privacy_policy' />
                            </a>
                    </div>
                </div>
                <div/>
                { 
                    devEnvironment &&
                    <div className="gi-footer__dev-container">
                        <div className="gi-footer__primary-section">
                            <div className="gi-footer__info gi-footer__info-heading">Dev Footer</div>
                            {devEnvironment && (!user || user?.role === ALL_USER_ROLES.INDIVIDUAL) &&
                                <Fragment>
                                    <a className="gi-footer__link" href={SIGNUP_AGENT_BROKER}><FormattedMessage id='footer.agent_broker' /></a>
                                    <a className="gi-footer__link" href={SIGNUP_ENROLLMENT_ENTITIES}><FormattedMessage id='footer.enrollment_entities' /></a>
                                    <a className="gi-footer__link" href={SIGNUP_AGENCY}><FormattedMessage id='footer.agency'/></a>
                                </Fragment>
                            }
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_date' values={{ date: sDate }} /></div>
                            <div className="gi-footer__info"><FormattedMessage id='footer.server_time' values={{ time: `${sTime} ${timezone}` }} /></div>
                        </div>
                    </div>
                }
            </footer>
        </Fragment>

    );
};

export default GeorgiaFooter;
